import marioPic from "@/public/images/artists/mario.png";
import { Artist } from "@/types/types";

export const mario = {
  id: "222",
  name: "Mario",
  image: marioPic,
  description: `Mario's voice is deep and warm, with a subtle nasal quality that gives it character. His unprocessed tone moves easily between bass and mid-range, rich with emotion and unpretentious grace.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmario-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Deep", "Indie", "Folk", "Jazz", "Latin"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 44,
        high: 68,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
